import { render, staticRenderFns } from "./CertificateList.vue?vue&type=template&id=02e79c4a&"
import script from "./CertificateList.vue?vue&type=script&lang=js&"
export * from "./CertificateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports